var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeatherRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 24.49248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-409 -22.2179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.4878,39.421a3.48285,3.48285,0,0,0,1.27592-6.73485,2.8503,2.8503,0,0,0-4.0747-2.99628,4.84176,4.84176,0,0,0-8.952,1.3347,4.354,4.354,0,0,0,1.6532,8.39643Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b",
    transform: "translate(-409 -22.2179)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 177,
    style: {
      fill: "none"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather_rain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22.20307,
    style: {
      fill: "#989798",
      opacity: 0.980000019073486
    }
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 24.13893,
    x2: 8.94975,
    y2: 19.18918,
    style: {
      fill: "none",
      stroke: "#21aacd",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 24.13893,
    x2: 13.94975,
    y2: 19.18918,
    style: {
      fill: "none",
      stroke: "#21aacd",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 24.13893,
    x2: 18.94975,
    y2: 19.18918,
    style: {
      fill: "none",
      stroke: "#21aacd",
      strokeMiterlimit: 10
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherRain);
export default __webpack_public_path__ + "static/media/weather_rain.c79e729dd1a119e73974bfb92dfa851c.svg";
export { ForwardRef as ReactComponent };